import {
  CancelMealReasonsService,
  type PostPutCancelMealReasonTranslationAdmin
} from '@/backend/market'
import { CancelMealReasonRepository } from '../../domain/repositories/CancelMealReasonRepository'
import { CancelMealReasonModel } from '../models/CancelMealReasonModel'
import { CancelMealReasonMiniModel } from '../models/CancelMealReasonMiniModel'
import type { CancelMealReasonMiniEntity } from '../../domain/entities/CancelMealReasonMiniEntity'
import type { CancelMealReasonEntity } from '../../domain/entities/CancelMealReasonEntity'

export class CancelMealReasonRepositoryImpl implements CancelMealReasonRepository {
  async getCancelMealReasons(): Promise<CancelMealReasonMiniEntity[] | { error: true }> {
    try {
      const response = await CancelMealReasonsService.getCancelMealReasonsAdmin({})
      const cancelMealReasonModels = response.map((reason) => new CancelMealReasonMiniModel(reason))

      return cancelMealReasonModels
    } catch {
      return { error: true }
    }
  }
  async getCancelMealReasonById(id: number): Promise<CancelMealReasonEntity | { error: true }> {
    try {
      const response = await CancelMealReasonsService.getCancelMealReasonByIdAdmin({
        id
      })
      const cancelMealReasonModel = new CancelMealReasonModel(response)

      return cancelMealReasonModel
    } catch {
      return { error: true }
    }
  }
  async createCancelMealReason(
    data: CancelMealReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await CancelMealReasonsService.postCancelMealReasonAdmin({
        requestBody: {
          translations: data.translations?.map((translation) => ({
            language: translation.language,
            title: translation.title
          })) as PostPutCancelMealReasonTranslationAdmin[]
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateCancelMealReason(
    id: number,
    data: CancelMealReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await CancelMealReasonsService.putCancelMealReasonAdmin({
        id,
        requestBody: {
          translations: data.translations?.map((translation) => ({
            language: translation.language,
            title: translation.title
          })) as PostPutCancelMealReasonTranslationAdmin[]
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteCancelMealReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await CancelMealReasonsService.deleteCancelMealReasonAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
